import { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TOKEN_SYNC_TS_KEY = 'tokenUpdatedAt';

const TokenRedirect = () => {

    const {tenant,token} = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation('global');

    useEffect(() => {
        if (!tenant || !token) return;

        const currentToken = localStorage.getItem('token');
        if (currentToken !== token) {
            localStorage.setItem('token', token);
            localStorage.setItem(TOKEN_SYNC_TS_KEY, Date.now().toString());
            localStorage.removeItem('user');
            localStorage.removeItem('userCurrentTs');
        }
        navigate(`/${tenant}`, { replace: true });
    }, [navigate, tenant, token]);
    
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
                <p className="text-gray-600">{t('auth.redirectingToTenantHome')}</p>
            </div>
        </div>
    )

}

export default TokenRedirect
